var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "106f5b4f63357eb53edee25c3f29cdf8c298ee85"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["frontend-nextrequest@nextrequest"] = {
  id: "106f5b4f63357eb53edee25c3f29cdf8c298ee85"
};